export async function getContentApi({ collection, vertical_id, ids, token }) {
  const res = await fetch(
    `${process.env.REACT_APP_FLASK_WEBSERVER}get_${collection}?ids=${ids}&collection=${collection}&vertical_id=${vertical_id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!res.ok) {
    throw new Error('Failed to get content');
  }

  return res.json();
}
